// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__TLqza","reference":"styles_reference__jFVsC","buttons":"styles_buttons__JYqXv"};